exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1srP_{position:relative;animation:_2SvG7 1.3s}@keyframes _2SvG7{0%,to{animation-timing-function:ease-out;left:0}85%{animation-timing-function:linear;left:-60px}}", ""]);

// exports
exports.locals = {
	"start-animation": "_1srP_",
	"startAnimation": "_1srP_",
	"reveal-swipe-option": "_2SvG7",
	"revealSwipeOption": "_2SvG7"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/mobile/views/home/components/first-time-track-animation/first-time-track-animation.styl
// module id = 2802
// module chunks = mobile/mobile